module.exports = __webpack_public_path__ + "img/logo.ee24e492.png";